import {paramsFromLocation} from '@yandex-delivery/utils/url'

export const isUsp = () => {
  const params = paramsFromLocation()

  return params.service === 'usp'
}
